<template>
  <div class='dataContainer' v-if='gotData'> 
    <div class="row">   
        <div class="col-xs-12 col-md-12" >      
            <!--<a  v-on:click='GoToPrev' v-if='this.imageIndex > 0' ><span class="glyphicon glyphicon-chevron-left glyphiconSize" style='float:left' ></span></a>-->
            <span >
                <a  v-on:click='GoToNext'  >
                    <img style="background:center no-repeat url();background-size:contain;width:100%;"  v-bind:src="currentImgPath" alt="Imagen" >
                </a>
            </span>
            <!--<a v-on:click='GoToNext' style='float:left'  v-if='this.imageIndex < this.imageLists.length-1'><span class="glyphicon glyphicon-chevron-right glyphiconSize"></span></a> -->                                                
        </div>
    </div>
    <div class="row">   
        <div class="col-xs-12 col-md-12" >            
            <div class='carPhotosList'>                
                <div v-for='(imageList, index) in imageLists'>
                    <a  v-on:click='ShowBigImage(index)'>
                        <img v-bind:src="imageFolderPath + imageList" alt="Imagen" height="120" width="120"><br>                        
                    </a>
                </div>                
            </div>
        </div>   
    </div>          
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {       
       imageIndex:0,
       currentImgPath:'',
       imageLists: [],
       imageFolderPath: '',
       gotData: false,
    }
  },
  mounted: function () {  
    this.imageFolderPath = this.$http.options.root + '/uploads/';

    //if(this.$route.params.id)
        //this.id = this.$route.params.id;

    //this.imageIndex = this.$route.params.imageIndex;          
    this.imageIndex = 0;          

    this.getCarImages();          
  },
  methods: {
     getCarImages : function(){

        this.$http.get('api/imageupload/carid/' + this.id).then(response => {                         
           this.imageLists = response.body.map(function(imageListsObj){                
                return imageListsObj.name;
           });                      
                      
           this.currentImgPath = this.imageFolderPath + this.imageLists[this.imageIndex];           
           this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },
    GoToPrev: function(){        
        this.imageIndex--;
        this.currentImgPath = this.imageFolderPath + this.imageLists[this.imageIndex];           
    },
    GoToNext: function(){        
        this.imageIndex++;  

        if(this.imageIndex == this.imageLists.length)
            this.imageIndex = 0;

        this.currentImgPath = this.imageFolderPath + this.imageLists[this.imageIndex];                   
    },
    ShowBigImage: function(index){        
        this.imageIndex = index;
        this.currentImgPath = this.imageFolderPath + this.imageLists[this.imageIndex];           
    },

  },
  filters: {
     
  },
  computed: {
    
  },  
  props:['id']
}
</script>

<style scoped>

    .dataContainer{              
       text-align: center;
    }

    .carPhotosList div {
       float: left;       
       margin: 5px;       
    }

    .glyphiconSize{
       font-size: 3em;
    } 


    @media screen and (max-width: 981px) {          
        .glyphiconSize{
            font-size: 8em;
        } 
   }
</style>



// WEBPACK FOOTER //
// Gallery.vue?f5e8ce34